import { openIntercomChat } from 'utils/openIntercomChat';

function onClick(e, event) {
  e.stopPropagation();
  e.preventDefault();
  event && event();
  openIntercomChat();
}

export default function withOpenIntercom(WrappedComponent) {
  return (wrappedComponentProps) => (
    <WrappedComponent
      {...wrappedComponentProps}
      onClick={(e) => onClick(e, wrappedComponentProps.event)}
    />
  );
}
